import styled from 'styled-components'

export const PolicyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: ${props => props.theme.palette.colors.muted};
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;

  p,
  address {
    margin: 0;
  }

  address {
    color: ${props => props.theme.palette.colors.muted};
    font-style: normal;
  }

  strong {
    color: ${props => props.theme.palette.colors.text};
    font-weight: 700;
  }

  a {
    color: ${props => props.theme.palette.blue.main};
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  @media (max-width: 767px) {
    gap: 28px;
    font-size: 15px;
    line-height: 1.65;
  }
`

export const PolicyIntro = styled.p`
  color: ${props => props.theme.palette.colors.text};
  font-family: Gilroy-Regular;
  font-size: 19px;
  line-height: 1.6;
  max-width: 72ch;

  @media (max-width: 767px) {
    font-size: 17px;
  }
`

export const PolicySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const PolicySectionTitle = styled.h2`
  margin: 0 0 2px;
  color: ${props => props.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.015em;

  @media (max-width: 767px) {
    font-size: 21px;
  }
`

export const PolicySubheading = styled.h3`
  margin: 8px 0 0;
  color: ${props => props.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
`

export const PolicyList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding-left: 24px;

  li::marker {
    color: ${props => props.theme.palette.blue.main};
  }
`
